import Flex from 'typescript-styled-flex'
import is from 'typescript-styled-is'
import styled from '../../../theme'

const FlexGroup = styled(Flex as any)<IFlexGroup>`
  padding: ${({ size }) => (size ? 0.3 * size : 0.3)}em
    ${({ size }) => (size ? 0.25 * size : 0.25)}em;
  ${is('row')`
    & > * + * {
      margin-left: ${({ size }) => (size ? 10 * size : 10)}px;
    }
  `}

  ${is('column')`
    & > * + * {
      margin-top: ${({ size }) => (size ? 10 * size : 10)}px;
    }
  `}
`

export default FlexGroup

interface IFlexGroup {
  size?: number
}
